"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckCircleFilled = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = require("react");
/**
 * チェックマーク部分が背景透過になっているので、
 * 背景色を持つタグ内で背景色をそのまま使用したい場合に使う
 */
var CheckCircleFilled = function (props) {
    var maskId = "vc-".concat((0, react_1.useId)());
    return ((0, jsx_runtime_1.jsx)(material_1.SvgIcon, __assign({}, props, { children: (0, jsx_runtime_1.jsxs)("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [(0, jsx_runtime_1.jsx)("defs", { children: (0, jsx_runtime_1.jsxs)("mask", { id: maskId, children: [(0, jsx_runtime_1.jsx)("rect", { width: "24", height: "24", fill: "white" }), (0, jsx_runtime_1.jsx)("path", { d: "M8 12l3 3 5.5-5.5", fill: "none", stroke: "black", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" })] }) }), (0, jsx_runtime_1.jsx)("circle", { cx: "12", cy: "12", r: "10", fill: "currentColor", mask: "url(#".concat(maskId, ")") })] }) })));
};
exports.CheckCircleFilled = CheckCircleFilled;
